import React from "react";
import { ControlProps, LabelProps } from "../../../components/Fields/Types";
import SettingGroupModel from "../../../models/settings/SettingGroupModel";
import SettingModel from "../../../models/settings/SettingModel";
import Setting from "./Setting";

export interface Props {
    getLabelProps: (string) => LabelProps
    getControlProps: (string) => ControlProps
    fieldName: string
    settingGroup: SettingGroupModel
}

const SettingGroup: React.FC<Props> = ({ fieldName, settingGroup, getLabelProps, getControlProps }) => {

    const settingFields = settingGroup.settings.map((setting: SettingModel, index: number) => {
        return <Setting fieldName={fieldName} index={index} getLabelProps={getLabelProps} getControlProps={getControlProps} settings={setting} />
    })

    return (
        <div className='col-xl-4' style={{ display: 'inline-block', verticalAlign: 'top' }} key={settingGroup.name}>
            <h2>{settingGroup.name}</h2>
            <div>
                {settingFields}
            </div>
        </div>
    )
}
export default SettingGroup;